import { Typography } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const ChatHeader = ({ mobileUserList, setMobileUserList, title }) => {

  return (
              <Typography variant="Header1"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  textAlign: 'center',
                  fontSize: '36px',
                  backgroundColor: 'background.paper',
                  width: { xs: '100%', md: '95%' },
                  marginBottom: '5px',
                  borderRadius: '5px',
                  boxShadow: '3px 3px lightGrey',
                }}
                onClick={() =>
                  setMobileUserList(!mobileUserList)}
              > {title} {!mobileUserList && (
                <KeyboardArrowDownIcon sx={{ display: { md: 'none' } }} />)}
                {mobileUserList && (<KeyboardArrowUpIcon sx={{ display: { md: 'none' } }} />)}
    
              </Typography>
  )
};

export default ChatHeader;